import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import router from './router'
import store from './store'
import axios from '~common/assets/js/axios'
import Axios from 'axios'
import utils from '~common/commonModule/magicCube/assets/js/utils'
import { $messageBox } from '~common/assets/js/modus'
import '~common/commonModule/magicCube/styles/main.scss'
import XesFrontendUI from '@xes/xes-frontend-ui'
import '@xes/xes-frontend-ui/lib/theme/index.css'
// import Katex from '@xes/xes-katex'
// import '@xes/xes-katex/dist/katex.css'
import 'dplayer/dist/DPlayer.min.css'
import { loadMathJax } from '@xes/xes-frontend-ui/lib/utils/useMathJax.js'
loadMathJax()
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(XesFrontendUI)
// Vue.use(Katex)
Vue.prototype.$axios = axios
Vue.prototype.$utils = utils
Vue.prototype.$msgBox = $messageBox
window.axios = axios
window.uploadAxios = Axios
Vue.directive('anchor', {
  inserted: function (el, binding) {
    el.onclick = function () {
      let id = '' + binding.value.id + binding.value.num + binding.value.deepth + binding.value.index
      document.documentElement.scrollTop = document.getElementById('anchor-' + id).offsetTop
    }
  }
})

// import '~common/commonModule/magicCube/MockData/previewMock.js'

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./module/magicCube/src/main.js